<template>
  <div class="mod-bubble"
       :style="cptStyle">
    <div class="content"
         :class="meta.pos"
         v-html="meta.text"></div>
  </div>
</template>

<script>
import { px2rem } from '@/utils'
export default {
  props: {
    meta: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      state: false
    }
  },
  computed: {
    cptStyle() {
      return {
        top: px2rem(this.meta.y),
        left: px2rem(this.meta.x)
      }
    }
  },
  mounted() {
    this.$event.on('Hide_All', () => {
      if (this.state) {
        this.hide()
      }
    })
    this.$event.on('Open', (num) => {
      if (this.meta.num === num) {
        if (!this.state) {
          this.show()
        }
      } else if (this.state) {
        this.hide()
      }
    })
  },
  methods: {
    hide() {
      this.$el.classList.remove('scaleIn')
      this.$el.classList.add('scaleOut')
      this.state = false
    },
    show() {
      this.$el.classList.remove('scaleOut')
      this.$el.classList.add('scaleIn')
      this.state = true
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-bubble {
  position: absolute;
  transform: scaleY(0);
  z-index: 10;
  .content {
    position: relative;
    padding: 8px;
    background: #fdf2e5;
    border: 4px solid #882104;
    border-radius: 10px;
    font-size: 28px;
    font-weight: bold;
    color: #882104;
    opacity: 0.9;
    white-space: pre-line;
    &::after {
      content: "";
      position: absolute;
      border-style: solid;
      border-color: transparent #fdf2e5 #fdf2e5 transparent;
      border-width: 10px;
      box-shadow: 4px 4px 0 0 #882104;
      z-index: 10;
    }
    &.top {
      &::after {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%) translateY(50%) rotate(45deg);
      }
    }
    &.bottom {
      &::after {
        top: 2px;
        left: 50%;
        transform: translateX(-50%) translateY(-50%) rotate(-135deg);
      }
    }
    &.right {
      &::after {
        top: 20%;
        left: 2px;
        transform: translateX(-50%) rotate(135deg);
      }
    }
    &.left {
      &::after {
        top: 50%;
        right: 2px;
        transform: translateX(50%) translateY(-50%) rotate(-45deg);
      }
    }
  }
}
@keyframes scaleIn {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
.scaleIn {
  transform: scaleY(1);
  animation: scaleIn 0.3s ease-in;
}
@keyframes scaleOut {
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0);
  }
}
.scaleOut {
  transform: scaleY(0);
  animation: scaleOut 0.3s ease-in;
}
</style>